// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorFault } from './elevator-fault';


export class ElevatorFaultMessage implements flatbuffers.IUnpackableObject<ElevatorFaultMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorFaultMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorFaultMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorFaultMessage):ElevatorFaultMessage {
  return (obj || new ElevatorFaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorFaultMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorFaultMessage):ElevatorFaultMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorFaultMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorFault {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorFault.LowerPitSwitch;
}

static startElevatorFaultMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorFault) {
  builder.addFieldInt16(0, message, ElevatorFault.LowerPitSwitch);
}

static endElevatorFaultMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorFaultMessage(builder:flatbuffers.Builder, message:ElevatorFault):flatbuffers.Offset {
  ElevatorFaultMessage.startElevatorFaultMessage(builder);
  ElevatorFaultMessage.addMessage(builder, message);
  return ElevatorFaultMessage.endElevatorFaultMessage(builder);
}

unpack(): ElevatorFaultMessageT {
  return new ElevatorFaultMessageT(
    this.message()
  );
}


unpackTo(_o: ElevatorFaultMessageT): void {
  _o.message = this.message();
}
}

export class ElevatorFaultMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorFault = ElevatorFault.LowerPitSwitch
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorFaultMessage.createElevatorFaultMessage(builder,
    this.message
  );
}
}
